/* eslint-disable jsx-a11y/img-redundant-alt */
import React from "react";
import { Autoplay, Pagination } from "swiper";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { useSiteData } from "../context/SiteDataContext";
import defaultData from "../data/testimonial.json";

const Testimonial = ({ isBg }) => {
  const { data, loading } = useSiteData();
  const testimonial = data?.testimonial || defaultData.testimonial;

  if (loading) return null;

  return (
    // <!-- ========== Testimonial section start ========== -->
    <section
      id="reviews"
      className={`section-padding testimonial ${isBg === "yes" ? "bg-one" : ""
        }`}
    >
      <div className="container">
        <div className="row">
          <div className="col-xl-6 offset-xl-3 col-lg-10 offset-lg-1">
            <div className="section-title-center text-center">
              <span>{testimonial.subtitle}</span>
              <h2 className="display-6">{testimonial.title}</h2>
              <div className="section-divider divider-traingle"></div>
            </div>
          </div>
        </div>
        <div className="row testi-row">
          <div className="col-12">
            <Swiper
              modules={[Pagination, Autoplay]}
              pagination={{ clickable: true }}
              //autoplay={{ delay: 15000 }}
              breakpoints={{
                768: {
                  slidesPerView: 2,
                  spaceBetween: 20,
                },
                1024: {
                  slidesPerView: 3,
                  spaceBetween: 20,
                },
              }}
            >
              {testimonial.testimonialItem?.map((data, index) => (
                <SwiperSlide key={data.id}>
                  <div className="swiper-slide p-5px-lr">
                    <div className="testi-card card h-100 translateEffect1" style={{ position: 'relative' }}>
                      <div className="card-body p-4" style={{ paddingBottom: data.bookImage ? '100px' : '16px' }}>
                        <div className="testi-card__quotation">
                          <i className="icofont-quote-right"></i>
                        </div>
                        <div className="testi-card__user-info pt-4">
                          <div className="testimonial__user-info__image">
                            <img src={data.image} alt={data.title} />
                          </div>
                          <div className="testimonial__user-info__content">
                            <h4 className="mb-0">{data.name}</h4>
                            <p className="mb-0">{data.title}</p>
                          </div>
                        </div>
                        <div className="my-4" dangerouslySetInnerHTML={{ __html: data.description }} />
                        
                        {/* Link section */}
                        {index >= testimonial.testimonialItem.length - 5 && data.link && (
                          <div style={{ marginTop: '16px' }}>
                            <i style={{ fontSize: '13px', color: '#666' }}>Avis publié sur lesnouveauxauteurs.com</i>
                            <br />
                            <a href={data.link} target="_blank" rel="noopener noreferrer" className="link" style={{ fontSize: '14px' }}>
                              Voir l'évaluation complète
                            </a>
                          </div>
                        )}
                      </div>
                      
                      {/* Book cover image - fixed position bottom right */}
                      {data.bookImage && (
                        <img 
                          src={data.bookImage} 
                          alt="Livre commenté" 
                          style={{
                            position: 'absolute',
                            bottom: '20px',
                            right: '20px',
                            width: '70px',
                            height: 'auto',
                            borderRadius: '4px',
                            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                            border: '2px solid #e8e8e8'
                          }}
                        />
                      )}
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </section>
    // <!-- ========== Testimonial section end ========== -->
  );
};

export default Testimonial;
